export const homeLogoPath = (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 1920.000000 1080.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
      fill="#fff"
      stroke-width="5"
    >
      <path
        d="M8135 7979 c-649 -203 -1204 -376 -1232 -384 l-53 -16 0 -1054 0
-1055 -300 0 -300 0 0 -75 0 -75 363 0 364 0 6 383 c4 210 7 700 7 1089 l0
707 58 17 c31 9 149 45 262 79 113 35 259 79 325 99 66 19 181 53 255 76 74
23 196 59 270 82 74 22 232 69 350 105 200 61 239 72 345 103 22 7 129 38 238
71 123 37 217 59 247 59 30 0 124 -22 247 -59 109 -33 216 -64 238 -71 106
-31 145 -42 345 -103 118 -36 276 -83 350 -105 74 -23 196 -59 270 -82 74 -23
189 -57 255 -76 66 -20 212 -64 325 -99 113 -34 231 -70 263 -79 l57 -17 0
-707 c0 -389 3 -879 7 -1089 l6 -383 364 0 363 0 0 75 0 75 -300 0 -300 0 0
1055 0 1054 -47 14 c-27 8 -584 182 -1239 386 -655 204 -1199 371 -1210 370
-10 0 -550 -167 -1199 -370z"
        class="svg-elem-1"
      ></path>
      <path
        d="M9243 7275 c4 -93 7 -602 7 -1132 l0 -963 976 0 975 0 -6 -47 c-41
-296 -142 -568 -298 -803 -119 -179 -303 -369 -470 -488 -75 -53 -112 -76
-232 -142 -64 -36 -244 -107 -341 -135 -133 -39 -300 -65 -466 -72 l-148 -6 0
-109 0 -108 93 0 c239 0 515 48 722 125 224 84 465 223 627 363 53 45 213 205
253 252 280 330 466 790 489 1215 l5 90 -1024 -3 -1025 -4 0 956 0 956 63 0
c34 0 106 -7 160 -15 671 -101 1216 -532 1475 -1167 l11 -28 98 46 c53 24 98
46 100 48 2 2 -17 48 -41 103 -220 495 -636 891 -1153 1097 -208 83 -426 126
-672 133 l-184 6 6 -168z"
        class="svg-elem-2"
      ></path>
      <path
        d="M8985 7414 c-277 -50 -558 -165 -812 -332 l-102 -67 -1 -149 0 -149
44 39 c220 195 494 341 771 409 l90 22 3 -1825 c1 -1004 0 -1827 -2 -1829 -8
-8 -214 50 -301 84 -255 101 -453 232 -642 425 -281 286 -425 554 -517 961
l-6 27 -110 0 c-75 0 -110 -4 -110 -11 0 -7 12 -64 26 -128 51 -227 164 -492
294 -690 195 -296 501 -564 821 -719 225 -108 393 -158 657 -196 l22 -3 -2
2071 c-3 2063 -3 2071 -23 2073 -11 1 -56 -5 -100 -13z"
        class="svg-elem-3"
      ></path>
      <path
        d="M10602 5536 c-18 -90 -32 -169 -32 -175 0 -6 11 -11 24 -11 24 0 36
16 36 51 0 17 6 20 33 17 28 -3 32 -7 35 -35 3 -29 7 -33 33 -33 24 0 29 4 25
18 -3 9 -17 80 -31 157 -34 182 -31 175 -64 175 l-28 0 -31 -164z m77 -48 c1
-22 -4 -28 -20 -28 -22 0 -22 10 -2 105 l7 30 7 -40 c4 -22 8 -52 8 -67z"
        class="svg-elem-4"
      ></path>
      <path
        d="M10780 5525 l0 -175 25 0 25 0 0 150 0 150 35 0 35 0 0 -50 c0 -47
-2 -50 -25 -50 -33 0 -33 -22 1 -122 24 -73 27 -78 55 -78 l28 0 -28 80 c-28
78 -28 79 -7 82 20 3 21 9 21 93 l0 90 -82 3 -83 3 0 -176z"
        class="svg-elem-5"
      ></path>
      <path
        d="M11000 5526 l0 -176 25 0 c25 0 25 1 26 88 l1 87 20 -72 c12 -42 26
-73 34 -73 7 0 20 26 29 58 9 31 18 62 20 67 2 6 4 -27 4 -72 1 -82 1 -83 26
-83 l25 0 0 175 0 175 -24 0 c-21 0 -27 -8 -41 -57 -9 -32 -21 -75 -28 -97
l-11 -38 -26 93 c-25 86 -29 94 -53 97 l-27 3 0 -175z"
        class="svg-elem-6"
      ></path>
      <path
        d="M11265 5599 c27 -80 35 -119 35 -176 l0 -73 30 0 30 0 0 68 c0 51 9
94 35 172 19 57 35 105 35 107 0 2 -13 3 -29 3 -27 0 -30 -4 -46 -65 -10 -36
-22 -62 -26 -58 -4 4 -14 33 -21 63 -13 51 -16 55 -46 58 l-31 3 34 -102z"
        class="svg-elem-7"
      ></path>
      <path
        d="M6840 4960 c0 -75 28 -262 57 -380 70 -289 210 -565 396 -780 110
-127 496 -475 731 -659 161 -125 268 -199 466 -323 544 -338 722 -428 850
-428 128 0 306 90 850 428 198 124 305 198 466 323 235 184 621 532 731 659
186 215 326 491 396 780 29 118 57 305 57 380 l0 50 -74 0 -73 0 -6 -137 c-13
-318 -104 -548 -346 -873 -95 -127 -347 -393 -364 -383 -5 3 -7 1 -3 -5 3 -6
-8 -21 -26 -34 -18 -12 -40 -30 -48 -39 -13 -13 -68 -61 -155 -132 -319 -263
-828 -587 -1277 -813 -114 -57 -142 -57 -256 0 -449 226 -958 550 -1277 813
-87 71 -142 119 -155 132 -8 9 -30 27 -48 39 -18 13 -29 28 -26 34 4 6 2 8 -3
5 -17 -10 -269 256 -364 383 -142 191 -220 329 -277 492 -45 126 -63 226 -69
381 l-6 137 -73 0 -74 0 0 -50z"
        class="svg-elem-8"
      ></path>
    </g>
  </svg>
);

export const OwnershipIcon = (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="90"
    height="90"
    viewBox="0 0 437.000000 437.000000"
    preserveAspectRatio="xMidYMid meet"
    id="homeIcon"
  >
    <g
      transform="translate(0.000000,437.000000) scale(0.100000,-0.100000)"
      fill="#fff"
      stroke="none"
    >
      <path
        d="M1090 3469 c-381 -68 -670 -339 -779 -730 -21 -79 -45 -212 -56 -319
-8 -73 -14 -88 -61 -146 -77 -93 -103 -233 -70 -364 35 -136 165 -298 326
-407 76 -52 127 -101 216 -208 130 -158 348 -361 537 -501 137 -102 157 -122
157 -156 0 -49 26 -95 70 -123 22 -14 43 -34 46 -43 27 -82 55 -106 170 -142
79 -24 283 -40 447 -34 56 2 172 6 257 8 111 4 176 11 230 26 41 11 130 25
197 30 319 27 579 149 783 367 117 125 205 271 277 458 46 118 71 166 144 277
104 158 177 318 231 502 57 198 56 501 -1 728 -57 226 -132 360 -291 519 -88
89 -119 113 -195 151 -176 90 -347 125 -550 115 -233 -12 -440 -92 -626 -242
-70 -56 -193 -197 -244 -277 -17 -27 -33 -48 -37 -48 -3 0 -17 17 -29 38 -30
49 -218 241 -294 301 -119 95 -240 153 -405 197 -76 21 -124 26 -245 29 -82 2
-175 0 -205 -6z m310 -69 c312 -38 546 -188 774 -492 48 -65 91 -118 95 -118
13 0 46 42 94 120 153 250 386 420 652 475 84 17 296 23 395 10 125 -15 297
-92 412 -183 154 -121 279 -341 333 -587 22 -96 31 -406 16 -518 -22 -167
-133 -427 -266 -627 -62 -94 -66 -98 -136 -129 -103 -46 -287 -98 -449 -126
-54 -10 -562 -15 -590 -6 -22 7 -18 10 35 25 108 32 178 83 190 137 4 16 23
42 46 60 55 43 83 101 75 152 -5 28 -2 47 10 64 21 33 22 105 1 137 -23 34
-21 47 9 76 52 49 59 104 19 156 -59 78 -227 111 -570 114 l-100 0 81 40 c95
46 154 104 154 151 0 37 -24 85 -49 99 -33 17 -147 12 -336 -16 -276 -40 -342
-64 -527 -196 -71 -50 -138 -59 -480 -59 -348 0 -468 12 -701 72 -61 15 -248
82 -265 94 -6 5 18 217 33 291 113 549 512 849 1045 784z m1200 -1045 c32 -39
-6 -67 -226 -161 -142 -60 -186 -92 -164 -119 11 -13 52 -15 309 -14 313 1
398 -6 483 -43 60 -26 76 -50 54 -83 -37 -56 -139 -84 -326 -91 -298 -9 -370
-13 -380 -19 -16 -10 -11 -42 8 -50 30 -13 283 -15 402 -3 181 19 226 17 252
-9 18 -19 20 -27 13 -49 -22 -62 -154 -93 -405 -95 -91 0 -190 -4 -220 -7 -50
-6 -55 -9 -55 -32 0 -21 6 -26 40 -32 69 -13 433 -1 500 16 78 20 114 20 122
1 3 -9 -3 -25 -13 -37 -45 -51 -155 -75 -389 -86 l-140 -7 -3 -33 c-3 -27 -7
-32 -20 -26 -96 42 -415 99 -554 99 -63 0 -82 -4 -106 -22 l-29 -22 -7 67
c-17 189 8 568 43 627 44 77 220 171 356 192 50 7 140 22 200 32 142 24 238
26 255 6z m-2090 -179 c246 -74 385 -89 825 -84 l357 3 -6 -70 c-15 -168 -19
-494 -7 -569 20 -126 38 -117 -237 -115 -277 2 -363 10 -515 48 -478 121 -768
384 -745 676 6 64 30 122 73 173 l25 30 73 -33 c39 -18 110 -45 157 -59z
m1620 -800 c96 -15 191 -32 210 -38 65 -20 173 -82 222 -128 l49 -45 15 -110
c21 -158 26 -420 10 -532 -8 -50 -17 -96 -20 -102 -21 -34 -216 -50 -596 -47
-282 2 -309 4 -361 23 -58 22 -99 44 -99 54 0 3 84 3 188 1 153 -4 190 -2 199
10 24 28 -2 38 -133 48 -270 22 -384 58 -384 121 0 12 40 10 185 -10 91 -13
406 -14 439 -1 31 11 34 35 7 50 -11 5 -82 10 -158 10 -346 1 -522 45 -494
123 13 36 70 49 164 37 90 -11 438 -12 477 -1 17 5 26 15 28 33 l3 27 -221 1
c-235 1 -344 13 -424 48 -51 23 -61 39 -52 78 16 64 190 90 558 82 253 -6 267
-4 253 41 -8 25 -51 51 -167 96 -182 73 -229 106 -207 148 13 24 50 22 309
-17z m739 -2 c-31 -37 -148 -74 -242 -75 -47 -1 -65 4 -97 25 -22 14 -40 31
-40 36 0 6 39 11 93 11 50 1 124 5 162 9 127 13 139 12 124 -6z m-2113 -14
c219 -76 350 -93 729 -94 l320 -1 75 -36 75 -36 -165 -7 c-200 -9 -296 -21
-367 -48 -70 -26 -111 -61 -119 -103 -8 -44 1 -70 43 -116 l35 -39 -25 -29
c-14 -17 -27 -36 -29 -43 -5 -15 -65 25 -197 130 -138 110 -467 442 -438 442
2 0 30 -9 63 -20z m3030 -107 c-12 -49 -90 -215 -141 -302 -56 -93 -177 -228
-266 -297 -159 -122 -379 -204 -592 -220 l-82 -7 3 259 c2 149 -1 299 -7 353
-7 52 -10 95 -9 96 2 1 143 5 313 8 360 6 422 15 630 86 77 26 144 49 149 49
4 1 5 -10 2 -25z"
        class="svg-elem-1"
      ></path>
    </g>
  </svg>
);

export const cloneCodeIcon = (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="90"
    height="90"
    viewBox="0 0 367.000000 367.000000"
    preserveAspectRatio="xMidYMid meet"
    id="homeIcon"
  >
    <g
      transform="translate(0.000000,367.000000) scale(0.100000,-0.100000)"
      fill="#fff"
      stroke="none"
    >
      <path
        d="M1635 3524 c-338 -52 -551 -138 -805 -325 -121 -89 -304 -276 -376
-384 -116 -175 -204 -373 -264 -600 -45 -167 -37 -582 15 -774 82 -304 192
-513 381 -725 112 -125 323 -305 359 -306 6 0 30 -16 54 -35 24 -19 48 -35 53
-35 6 0 64 -23 131 -51 70 -30 186 -68 276 -90 l154 -39 239 0 c136 0 247 4
257 10 10 5 70 20 132 34 102 22 259 73 299 97 8 5 26 14 40 20 102 43 270
157 378 255 290 266 469 580 544 956 32 162 32 439 -1 618 -66 359 -229 662
-497 922 -263 255 -591 407 -974 453 -151 18 -274 18 -395 -1z m352 -124 c252
-22 492 -107 712 -250 116 -75 374 -328 443 -435 125 -191 211 -418 249 -660
7 -44 13 -147 12 -230 -1 -330 -100 -618 -313 -915 -49 -68 -233 -254 -280
-283 -19 -12 -49 -35 -66 -52 -16 -17 -63 -48 -102 -68 -40 -21 -72 -42 -72
-48 0 -5 -8 -9 -18 -9 -10 0 -70 -22 -133 -50 -62 -27 -121 -50 -129 -50 -8 0
-44 -10 -80 -22 -60 -19 -86 -21 -345 -21 -287 1 -398 11 -476 46 -19 8 -62
24 -97 36 -74 26 -274 132 -364 192 -102 69 -297 273 -382 402 -114 170 -193
355 -230 532 -22 107 -39 358 -31 470 35 514 381 1017 868 1262 259 130 531
180 834 153z"
        class="svg-elem-1"
      ></path>
      <path
        d="M1271 2629 c-97 -12 -232 -82 -306 -158 -68 -70 -115 -142 -146 -221
-30 -77 -37 -249 -15 -345 28 -119 71 -177 342 -455 137 -140 260 -268 274
-284 42 -47 376 -363 404 -381 29 -19 76 -13 76 9 0 16 32 46 51 47 8 0 34 24
58 52 24 29 188 201 365 382 176 182 347 360 378 396 94 108 138 229 138 379
0 201 -89 374 -244 478 -170 114 -373 136 -567 63 -56 -21 -162 -95 -208 -144
l-24 -26 -73 63 c-149 127 -301 171 -503 145z m224 -134 c83 -22 137 -55 240
-145 49 -44 97 -80 107 -80 10 0 57 36 105 80 141 128 220 160 397 160 87 0
98 -2 166 -36 93 -47 177 -129 220 -218 29 -59 34 -79 38 -169 7 -152 -7 -202
-78 -290 -32 -40 -236 -251 -452 -471 l-393 -398 -387 388 c-490 492 -517 525
-538 660 -23 142 31 294 144 408 33 34 79 71 101 81 95 45 226 57 330 30z"
        class="svg-elem-2"
      ></path>
      <path
        d="M1900 2130 c-11 -21 -29 -63 -41 -92 -11 -29 -52 -129 -91 -221 l-71
-168 -19 29 c-10 17 -53 58 -95 93 l-76 63 59 53 c32 29 72 59 87 66 26 11 28
16 25 61 -5 91 -49 85 -182 -23 -94 -77 -146 -136 -146 -165 0 -17 25 -44 100
-107 137 -115 193 -141 229 -106 11 10 12 7 6 -13 -4 -14 -9 -30 -12 -35 -6
-17 36 -55 62 -55 14 0 31 11 43 28 41 57 232 541 232 587 0 27 -25 45 -64 45
-20 0 -30 -9 -46 -40z"
        class="svg-elem-3"
      ></path>
      <path
        d="M2019 2059 c-30 -30 -17 -55 72 -140 89 -84 90 -92 28 -134 -48 -34
-119 -110 -119 -128 0 -23 31 -57 52 -57 28 0 140 76 216 147 82 77 83 100 10
171 -29 28 -73 66 -98 84 -101 75 -132 86 -161 57z"
        class="svg-elem-4"
      ></path>
    </g>
  </svg>
);

export const empathyToCustomer = (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="90"
    height="90"
    viewBox="0 0 412.000000 412.000000"
    preserveAspectRatio="xMidYMid meet"
    id="homeIcon"
  >
    <g
      transform="translate(0.000000,412.000000) scale(0.100000,-0.100000)"
      fill="#fff"
      stroke="none"
    >
      <path
        d="M2735 3880 c-167 -17 -349 -134 -461 -296 -75 -108 -111 -283 -94
-450 17 -163 65 -264 185 -388 82 -84 179 -145 285 -178 98 -30 282 -32 375
-4 130 39 257 124 350 235 97 114 135 229 135 406 0 155 -10 209 -61 315 -34
69 -58 101 -128 171 -52 52 -111 100 -151 121 -103 57 -280 85 -435 68z m346
-152 c91 -45 191 -135 238 -212 182 -303 75 -645 -253 -811 l-98 -50 -122 0
-121 0 -95 47 c-127 62 -184 108 -245 198 -69 102 -87 160 -93 296 -5 127 8
189 61 289 61 114 222 248 332 276 16 4 96 7 176 6 l145 -2 75 -37z"
        class="svg-elem-1"
      ></path>
      <path
        d="M1132 3536 c-105 -35 -202 -97 -297 -190 -67 -66 -90 -97 -123 -166
-53 -112 -66 -173 -66 -300 0 -118 19 -200 65 -292 35 -69 67 -88 105 -63 13
8 24 20 24 26 0 5 -17 51 -37 102 -36 90 -37 94 -37 233 l-1 141 45 89 c106
209 287 324 510 324 166 0 270 -42 381 -150 177 -174 219 -376 133 -638 -29
-91 -30 -118 -4 -132 37 -20 68 -2 94 55 33 68 63 182 71 267 13 124 -34 303
-109 414 -93 137 -271 260 -424 293 -93 19 -247 13 -330 -13z"
        class="svg-elem-2"
      ></path>
      <path
        d="M1440 2453 c-52 -10 -67 -54 -30 -88 17 -15 45 -20 158 -26 157 -8
239 -26 329 -75 77 -41 107 -43 129 -9 15 22 15 29 4 51 -49 91 -407 180 -590
147z"
        class="svg-elem-3"
      ></path>
      <path
        d="M2975 2450 c-158 -19 -248 -52 -700 -260 -181 -84 -373 -171 -425
-195 l-94 -42 -111 72 c-60 40 -175 117 -255 173 -174 121 -285 188 -354 214
-42 17 -69 19 -156 16 -92 -4 -111 -8 -153 -32 -219 -127 -269 -406 -106 -589
54 -60 150 -128 544 -382 312 -201 405 -250 499 -265 111 -17 176 -3 430 97
76 30 141 51 145 48 3 -4 9 -183 12 -398 3 -216 9 -400 13 -410 10 -21 54 -33
75 -20 24 15 28 66 36 495 l8 397 243 96 c277 110 339 144 339 190 0 30 0 30
-55 29 -42 -1 -94 -17 -220 -67 -91 -36 -286 -113 -435 -171 -148 -59 -279
-111 -291 -115 -77 -33 -189 -53 -264 -49 -107 6 -154 31 -535 278 -439 286
-446 290 -482 338 -32 43 -33 45 -33 149 0 119 10 149 68 206 44 43 123 67
222 67 l66 0 150 -101 c82 -56 232 -158 333 -228 236 -162 240 -163 300 -143
25 8 242 105 481 214 239 110 474 212 521 228 48 16 133 34 189 41 87 11 117
11 208 -3 170 -25 251 -63 359 -169 101 -99 174 -233 193 -355 6 -39 14 -337
19 -684 4 -338 11 -623 15 -632 8 -18 40 -23 70 -12 14 6 16 65 16 568 -1 308
-5 629 -9 712 -8 136 -12 157 -40 218 -71 157 -188 293 -316 367 -183 106
-314 133 -520 109z"
        class="svg-elem-4"
      ></path>
      <path
        d="M322 1967 c-45 -47 -47 -90 -47 -812 l0 -680 32 -3 c58 -6 57 -17 65
663 6 505 10 637 24 713 l16 93 -23 25 c-28 30 -40 30 -67 1z"
        class="svg-elem-5"
      ></path>
      <path
        d="M690 1300 c-12 -7 -16 -47 -20 -212 -3 -112 -3 -290 0 -395 6 -216
10 -229 68 -217 l32 7 0 413 0 414 -32 0 c-18 0 -40 -5 -48 -10z"
        class="svg-elem-6"
      ></path>
      <path
        d="M1910 888 c-11 -13 -23 -33 -26 -45 -8 -31 1 -324 10 -345 18 -40 81
-33 93 10 5 15 8 102 8 193 0 150 -2 169 -19 188 -24 27 -40 27 -66 -1z"
        class="svg-elem-7"
      ></path>
    </g>
  </svg>
);

export const commitmentQuality = (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="90"
    height="90"
    viewBox="0 0 440.000000 440.000000"
    preserveAspectRatio="xMidYMid meet"
    id="homeIcon"
  >
    <g
      transform="translate(0.000000,440.000000) scale(0.100000,-0.100000)"
      fill="#fff"
      stroke="none"
    >
      <path
        d="M2005 4197 c-151 -39 -335 -183 -418 -327 -86 -151 -106 -378 -48
-553 55 -169 227 -348 397 -414 61 -23 87 -27 215 -31 173 -5 238 8 345 69
240 137 367 371 351 647 -3 54 -15 126 -26 163 -56 177 -259 382 -431 434 -73
22 -315 30 -385 12z m286 -137 c64 -12 179 -67 232 -111 49 -40 108 -120 136
-183 94 -214 55 -441 -103 -599 -218 -217 -566 -211 -771 15 -96 106 -134 209
-135 359 0 146 51 270 153 372 130 130 302 182 488 147z"
        class="svg-elem-1"
      ></path>
      <path
        d="M2264 3619 l-154 -152 -80 77 c-101 96 -121 106 -158 79 -51 -38 -43
-58 75 -179 60 -61 123 -119 140 -127 31 -17 32 -17 85 24 63 49 269 258 310
313 46 63 30 116 -33 116 -25 0 -55 -24 -185 -151z"
        class="svg-elem-2"
      ></path>
      <path
        d="M3404 3712 c-6 -4 -25 -28 -42 -53 -31 -45 -34 -47 -94 -54 -103 -12
-105 -26 -22 -115 l44 -47 -20 -58 c-24 -70 -25 -101 -4 -109 18 -7 42 4 107
51 l47 35 62 -46 c34 -25 68 -46 75 -46 26 0 30 41 13 116 l-17 73 29 28 c40
38 73 92 62 103 -5 5 -38 10 -73 12 l-65 3 -25 44 c-28 48 -60 74 -77 63z
m106 -184 c11 -3 11 -9 -3 -28 -9 -14 -17 -39 -17 -57 0 -32 -21 -46 -35 -23
-9 15 -42 12 -75 -5 l-30 -16 0 44 c0 23 -7 52 -15 64 -14 19 -13 21 10 27 14
4 35 22 47 40 l23 34 41 -37 c22 -21 47 -40 54 -43z"
        class="svg-elem-3"
      ></path>
      <path
        d="M941 3626 c-40 -53 -43 -55 -101 -62 -97 -11 -100 -18 -36 -95 l54
-66 -20 -73 c-17 -64 -18 -74 -5 -87 13 -13 19 -13 48 2 19 10 53 31 76 48
l42 29 60 -47 c90 -71 114 -53 84 66 l-18 72 33 35 c84 88 81 112 -13 112 -62
0 -66 1 -77 28 -12 28 -67 92 -79 92 -4 0 -25 -25 -48 -54z m134 -132 l22 -5
-18 -37 c-11 -20 -19 -47 -19 -59 0 -27 -2 -28 -39 -9 -25 13 -31 13 -60 -5
-42 -25 -43 -25 -35 17 5 28 2 42 -15 65 -21 28 -21 29 -2 29 11 0 34 17 52
39 l31 39 30 -34 c17 -19 40 -37 53 -40z"
        class="svg-elem-4"
      ></path>
      <path
        d="M514 2840 c-75 -37 -92 -74 -272 -590 -153 -441 -222 -653 -222 -689
0 -80 55 -143 167 -192 113 -50 266 -99 307 -99 29 0 62 10 101 31 l58 31 91
-36 91 -36 3 -52 c4 -98 74 -190 165 -221 47 -15 51 -22 67 -101 11 -53 19
-66 67 -112 30 -29 68 -56 84 -59 35 -8 54 -33 70 -97 14 -60 72 -127 146
-171 53 -30 57 -36 78 -100 27 -84 49 -114 110 -152 64 -40 155 -47 217 -16
88 43 289 222 315 281 9 19 16 64 17 100 1 78 -27 135 -99 198 l-45 39 15 49
c20 66 19 103 -5 167 -25 66 -85 127 -147 148 -49 16 -48 14 -74 114 -26 101
-114 164 -241 174 l-76 6 -34 49 c-53 79 -98 109 -168 114 -114 8 -135 0 -245
-93 -55 -47 -115 -97 -133 -111 l-33 -27 -82 38 c-45 21 -86 41 -90 45 -6 6
313 923 326 936 2 2 46 0 98 -6 198 -21 383 -8 472 33 60 27 82 55 73 93 -11
43 -41 48 -156 24 -142 -29 -222 -35 -305 -21 -129 20 -139 25 -153 75 -24 91
-94 139 -319 216 -130 45 -180 49 -239 20z m256 -174 c129 -52 160 -72 160
-102 0 -14 -18 -82 -41 -152 -63 -196 -309 -881 -336 -939 -23 -48 -28 -53
-58 -53 -67 0 -324 97 -326 123 -3 29 5 60 43 177 56 173 281 823 308 890 12
30 26 66 31 79 9 22 14 23 67 19 34 -3 96 -20 152 -42z m541 -1186 c25 -14 49
-62 49 -97 0 -41 -38 -91 -117 -155 -146 -119 -182 -131 -234 -79 -23 23 -29
38 -29 73 0 41 4 47 86 126 136 129 193 160 245 132z m358 -206 c14 -18 21
-41 21 -70 0 -41 -3 -45 -107 -143 -133 -123 -240 -210 -271 -218 -31 -8 -68
13 -92 53 -42 67 -27 92 146 249 136 123 186 155 240 155 34 0 47 -5 63 -26z
m215 -269 c20 -19 26 -33 26 -67 -1 -55 -12 -73 -85 -139 -267 -240 -305 -261
-366 -200 -29 29 -33 42 -29 91 3 39 22 62 127 152 193 166 224 188 264 188
24 0 44 -8 63 -25z m110 -358 c36 -29 49 -85 29 -126 -21 -42 -141 -154 -205
-191 -78 -44 -123 -38 -153 20 -36 70 -15 108 124 224 132 110 150 116 205 73z"
        class="svg-elem-5"
      ></path>
      <path
        d="M3610 2751 c-130 -43 -252 -103 -282 -140 -15 -17 -36 -52 -47 -77
-11 -24 -27 -47 -36 -51 -40 -15 -216 47 -406 142 -155 78 -180 85 -314 85
-140 0 -329 -15 -404 -31 -62 -13 -102 -46 -238 -194 -110 -120 -318 -368
-344 -410 -23 -36 -26 -140 -6 -188 35 -81 161 -155 282 -164 69 -5 79 -4 138
25 75 37 233 167 311 255 61 70 86 126 86 193 0 34 -5 47 -26 63 -15 12 -32
21 -39 21 -20 0 -63 -57 -76 -101 -7 -22 -31 -61 -53 -86 -47 -53 -206 -187
-249 -209 -33 -18 -119 -20 -158 -5 -36 13 -99 70 -99 88 0 24 136 194 338
424 136 157 133 155 332 168 293 19 294 19 419 -43 237 -119 356 -160 490
-170 41 -3 78 -9 83 -14 15 -15 328 -915 328 -943 0 -8 -12 -21 -28 -30 -15
-9 -62 -37 -104 -64 l-78 -48 -77 74 c-129 122 -633 554 -756 648 -97 73 -157
69 -157 -11 0 -27 13 -39 445 -413 171 -147 338 -295 373 -329 57 -56 62 -64
62 -104 0 -49 -29 -86 -76 -98 -38 -10 -77 13 -216 128 -132 108 -166 123
-204 87 -13 -12 -24 -31 -24 -42 0 -13 46 -66 116 -138 65 -64 121 -125 127
-134 16 -29 -9 -93 -46 -115 -59 -36 -78 -28 -234 102 -105 88 -140 113 -171
121 -32 8 -62 -24 -62 -64 0 -27 17 -49 121 -150 l122 -119 -7 -42 c-10 -60
-39 -88 -92 -88 -45 0 -62 11 -238 155 -99 80 -126 91 -161 64 -48 -38 -36
-62 90 -187 140 -138 153 -172 88 -237 -26 -25 -32 -27 -83 -20 -113 14 -140
4 -140 -50 0 -56 68 -94 170 -94 101 -1 162 43 215 152 l30 62 54 8 c91 12
153 63 195 158 25 57 39 69 80 69 38 0 124 50 156 89 16 21 38 59 49 84 18 41
24 47 58 52 55 8 139 52 173 91 16 19 34 53 41 76 6 24 13 48 15 55 3 14 83
73 175 129 64 40 66 41 90 24 35 -25 86 -40 135 -40 49 0 199 49 321 105 68
31 88 45 112 82 40 59 46 107 25 179 -19 66 -267 771 -338 962 -55 146 -66
170 -98 198 -67 62 -146 69 -278 25z m192 -156 c45 -86 375 -1012 385 -1080 5
-37 2 -44 -22 -63 -28 -22 -199 -92 -273 -112 -33 -8 -47 -8 -57 0 -15 12 -66
139 -142 350 -83 232 -239 684 -258 747 -17 60 -17 64 -1 82 28 31 282 132
321 128 13 -1 30 -20 47 -52z"
        class="svg-elem-6"
      ></path>
    </g>
  </svg>
);

//technology exportise icons

export const reactIcon = (
  <svg
    height="70"
    viewBox="175.7 78 490.6 436.9"
    width="70"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#61dafb">
      <path
        d="m666.3 296.5c0-32.5-40.7-63.3-103.1-82.4 14.4-63.6 8-114.2-20.2-130.4-6.5-3.8-14.1-5.6-22.4-5.6v22.3c4.6 0 8.3.9 11.4 2.6 13.6 7.8 19.5 37.5 14.9 75.7-1.1 9.4-2.9 19.3-5.1 29.4-19.6-4.8-41-8.5-63.5-10.9-13.5-18.5-27.5-35.3-41.6-50 32.6-30.3 63.2-46.9 84-46.9v-22.3c-27.5 0-63.5 19.6-99.9 53.6-36.4-33.8-72.4-53.2-99.9-53.2v22.3c20.7 0 51.4 16.5 84 46.6-14 14.7-28 31.4-41.3 49.9-22.6 2.4-44 6.1-63.6 11-2.3-10-4-19.7-5.2-29-4.7-38.2 1.1-67.9 14.6-75.8 3-1.8 6.9-2.6 11.5-2.6v-22.3c-8.4 0-16 1.8-22.6 5.6-28.1 16.2-34.4 66.7-19.9 130.1-62.2 19.2-102.7 49.9-102.7 82.3 0 32.5 40.7 63.3 103.1 82.4-14.4 63.6-8 114.2 20.2 130.4 6.5 3.8 14.1 5.6 22.5 5.6 27.5 0 63.5-19.6 99.9-53.6 36.4 33.8 72.4 53.2 99.9 53.2 8.4 0 16-1.8 22.6-5.6 28.1-16.2 34.4-66.7 19.9-130.1 62-19.1 102.5-49.9 102.5-82.3zm-130.2-66.7c-3.7 12.9-8.3 26.2-13.5 39.5-4.1-8-8.4-16-13.1-24-4.6-8-9.5-15.8-14.4-23.4 14.2 2.1 27.9 4.7 41 7.9zm-45.8 106.5c-7.8 13.5-15.8 26.3-24.1 38.2-14.9 1.3-30 2-45.2 2-15.1 0-30.2-.7-45-1.9-8.3-11.9-16.4-24.6-24.2-38-7.6-13.1-14.5-26.4-20.8-39.8 6.2-13.4 13.2-26.8 20.7-39.9 7.8-13.5 15.8-26.3 24.1-38.2 14.9-1.3 30-2 45.2-2 15.1 0 30.2.7 45 1.9 8.3 11.9 16.4 24.6 24.2 38 7.6 13.1 14.5 26.4 20.8 39.8-6.3 13.4-13.2 26.8-20.7 39.9zm32.3-13c5.4 13.4 10 26.8 13.8 39.8-13.1 3.2-26.9 5.9-41.2 8 4.9-7.7 9.8-15.6 14.4-23.7 4.6-8 8.9-16.1 13-24.1zm-101.4 106.7c-9.3-9.6-18.6-20.3-27.8-32 9 .4 18.2.7 27.5.7 9.4 0 18.7-.2 27.8-.7-9 11.7-18.3 22.4-27.5 32zm-74.4-58.9c-14.2-2.1-27.9-4.7-41-7.9 3.7-12.9 8.3-26.2 13.5-39.5 4.1 8 8.4 16 13.1 24s9.5 15.8 14.4 23.4zm73.9-208.1c9.3 9.6 18.6 20.3 27.8 32-9-.4-18.2-.7-27.5-.7-9.4 0-18.7.2-27.8.7 9-11.7 18.3-22.4 27.5-32zm-74 58.9c-4.9 7.7-9.8 15.6-14.4 23.7-4.6 8-8.9 16-13 24-5.4-13.4-10-26.8-13.8-39.8 13.1-3.1 26.9-5.8 41.2-7.9zm-90.5 125.2c-35.4-15.1-58.3-34.9-58.3-50.6s22.9-35.6 58.3-50.6c8.6-3.7 18-7 27.7-10.1 5.7 19.6 13.2 40 22.5 60.9-9.2 20.8-16.6 41.1-22.2 60.6-9.9-3.1-19.3-6.5-28-10.2zm53.8 142.9c-13.6-7.8-19.5-37.5-14.9-75.7 1.1-9.4 2.9-19.3 5.1-29.4 19.6 4.8 41 8.5 63.5 10.9 13.5 18.5 27.5 35.3 41.6 50-32.6 30.3-63.2 46.9-84 46.9-4.5-.1-8.3-1-11.3-2.7zm237.2-76.2c4.7 38.2-1.1 67.9-14.6 75.8-3 1.8-6.9 2.6-11.5 2.6-20.7 0-51.4-16.5-84-46.6 14-14.7 28-31.4 41.3-49.9 22.6-2.4 44-6.1 63.6-11 2.3 10.1 4.1 19.8 5.2 29.1zm38.5-66.7c-8.6 3.7-18 7-27.7 10.1-5.7-19.6-13.2-40-22.5-60.9 9.2-20.8 16.6-41.1 22.2-60.6 9.9 3.1 19.3 6.5 28.1 10.2 35.4 15.1 58.3 34.9 58.3 50.6-.1 15.7-23 35.6-58.4 50.6z"
        class="svg-elem-1"
      ></path>
      <circle cx="420.9" cy="296.5" r="45.7" class="svg-elem-2"></circle>
    </g>
  </svg>
);
export const angularIcon = (
  <svg
    width="70"
    height="70"
    viewBox="0 0 256 272"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid"
  >
    <path
      d="M.1 45.522L125.908.697l129.196 44.028-20.919 166.45-108.277 59.966-106.583-59.169L.1 45.522z"
      fill="#E23237"
      class="svg-elem-1"
    ></path>
    <path
      d="M255.104 44.725L125.908.697v270.444l108.277-59.866 20.919-166.55z"
      fill="#B52E31"
      class="svg-elem-2"
    ></path>
    <path
      d="M126.107 32.274L47.714 206.693l29.285-.498 15.739-39.347h70.325l17.233 39.845 27.99.498-82.179-174.917zm.2 55.882l26.496 55.383h-49.806l23.31-55.383z"
      fill="#FFF"
      class="svg-elem-3"
    ></path>
  </svg>
);
export const vueIcon = (
  <svg
    enable-background="new 0 0 2500 2165.1"
    viewBox="0 0 2500 2165.1"
    xmlns="http://www.w3.org/2000/svg"
    width="55"
    height="55"
  >
    <path
      d="m1538.7 0-288.7 500-288.7-500h-961.3l1250 2165.1 1250-2165.1z"
      fill="#4dba87"
      class="svg-elem-1"
    ></path>
    <path
      d="m1538.7 0-288.7 500-288.7-500h-461.3l750 1299 750-1299z"
      fill="#435466"
      class="svg-elem-2"
    ></path>
  </svg>
);
export const reactNativeIcon = (
  <svg
    height="70"
    viewBox="175.7 78 490.6 436.9"
    width="70"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#61dafb">
      <path
        d="m666.3 296.5c0-32.5-40.7-63.3-103.1-82.4 14.4-63.6 8-114.2-20.2-130.4-6.5-3.8-14.1-5.6-22.4-5.6v22.3c4.6 0 8.3.9 11.4 2.6 13.6 7.8 19.5 37.5 14.9 75.7-1.1 9.4-2.9 19.3-5.1 29.4-19.6-4.8-41-8.5-63.5-10.9-13.5-18.5-27.5-35.3-41.6-50 32.6-30.3 63.2-46.9 84-46.9v-22.3c-27.5 0-63.5 19.6-99.9 53.6-36.4-33.8-72.4-53.2-99.9-53.2v22.3c20.7 0 51.4 16.5 84 46.6-14 14.7-28 31.4-41.3 49.9-22.6 2.4-44 6.1-63.6 11-2.3-10-4-19.7-5.2-29-4.7-38.2 1.1-67.9 14.6-75.8 3-1.8 6.9-2.6 11.5-2.6v-22.3c-8.4 0-16 1.8-22.6 5.6-28.1 16.2-34.4 66.7-19.9 130.1-62.2 19.2-102.7 49.9-102.7 82.3 0 32.5 40.7 63.3 103.1 82.4-14.4 63.6-8 114.2 20.2 130.4 6.5 3.8 14.1 5.6 22.5 5.6 27.5 0 63.5-19.6 99.9-53.6 36.4 33.8 72.4 53.2 99.9 53.2 8.4 0 16-1.8 22.6-5.6 28.1-16.2 34.4-66.7 19.9-130.1 62-19.1 102.5-49.9 102.5-82.3zm-130.2-66.7c-3.7 12.9-8.3 26.2-13.5 39.5-4.1-8-8.4-16-13.1-24-4.6-8-9.5-15.8-14.4-23.4 14.2 2.1 27.9 4.7 41 7.9zm-45.8 106.5c-7.8 13.5-15.8 26.3-24.1 38.2-14.9 1.3-30 2-45.2 2-15.1 0-30.2-.7-45-1.9-8.3-11.9-16.4-24.6-24.2-38-7.6-13.1-14.5-26.4-20.8-39.8 6.2-13.4 13.2-26.8 20.7-39.9 7.8-13.5 15.8-26.3 24.1-38.2 14.9-1.3 30-2 45.2-2 15.1 0 30.2.7 45 1.9 8.3 11.9 16.4 24.6 24.2 38 7.6 13.1 14.5 26.4 20.8 39.8-6.3 13.4-13.2 26.8-20.7 39.9zm32.3-13c5.4 13.4 10 26.8 13.8 39.8-13.1 3.2-26.9 5.9-41.2 8 4.9-7.7 9.8-15.6 14.4-23.7 4.6-8 8.9-16.1 13-24.1zm-101.4 106.7c-9.3-9.6-18.6-20.3-27.8-32 9 .4 18.2.7 27.5.7 9.4 0 18.7-.2 27.8-.7-9 11.7-18.3 22.4-27.5 32zm-74.4-58.9c-14.2-2.1-27.9-4.7-41-7.9 3.7-12.9 8.3-26.2 13.5-39.5 4.1 8 8.4 16 13.1 24s9.5 15.8 14.4 23.4zm73.9-208.1c9.3 9.6 18.6 20.3 27.8 32-9-.4-18.2-.7-27.5-.7-9.4 0-18.7.2-27.8.7 9-11.7 18.3-22.4 27.5-32zm-74 58.9c-4.9 7.7-9.8 15.6-14.4 23.7-4.6 8-8.9 16-13 24-5.4-13.4-10-26.8-13.8-39.8 13.1-3.1 26.9-5.8 41.2-7.9zm-90.5 125.2c-35.4-15.1-58.3-34.9-58.3-50.6s22.9-35.6 58.3-50.6c8.6-3.7 18-7 27.7-10.1 5.7 19.6 13.2 40 22.5 60.9-9.2 20.8-16.6 41.1-22.2 60.6-9.9-3.1-19.3-6.5-28-10.2zm53.8 142.9c-13.6-7.8-19.5-37.5-14.9-75.7 1.1-9.4 2.9-19.3 5.1-29.4 19.6 4.8 41 8.5 63.5 10.9 13.5 18.5 27.5 35.3 41.6 50-32.6 30.3-63.2 46.9-84 46.9-4.5-.1-8.3-1-11.3-2.7zm237.2-76.2c4.7 38.2-1.1 67.9-14.6 75.8-3 1.8-6.9 2.6-11.5 2.6-20.7 0-51.4-16.5-84-46.6 14-14.7 28-31.4 41.3-49.9 22.6-2.4 44-6.1 63.6-11 2.3 10.1 4.1 19.8 5.2 29.1zm38.5-66.7c-8.6 3.7-18 7-27.7 10.1-5.7-19.6-13.2-40-22.5-60.9 9.2-20.8 16.6-41.1 22.2-60.6 9.9 3.1 19.3 6.5 28.1 10.2 35.4 15.1 58.3 34.9 58.3 50.6-.1 15.7-23 35.6-58.4 50.6z"
        class="svg-elem-1"
      ></path>
      <circle cx="420.9" cy="296.5" r="45.7" class="svg-elem-2"></circle>
    </g>
  </svg>
);
export const nodeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="200"
    height="200"
    version="1.2"
    viewBox="0 0 442.37 270.929"
  >
    <defs>
      <clipPath id="a">
        <path
          d="M239.03 226.605l-42.13 24.317c-1.578.91-2.546 2.59-2.546 4.406v48.668c0 1.817.968 3.496 2.546 4.406l42.133 24.336c1.575.907 3.517.907 5.09 0l42.126-24.336c1.57-.91 2.54-2.59 2.54-4.406v-48.668c0-1.816-.97-3.496-2.55-4.406l-42.12-24.317c-.79-.453-1.67-.68-2.55-.68-.88 0-1.76.227-2.55.68"
          class="svg-elem-1"
        ></path>
      </clipPath>
      <linearGradient
        id="b"
        x1="-.348"
        x2="1.251"
        gradientTransform="rotate(116.114 53.1 202.97) scale(86.48)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".3" stop-color="#3E863D"></stop>
        <stop offset=".5" stop-color="#55934F"></stop>
        <stop offset=".8" stop-color="#5AAD45"></stop>
      </linearGradient>
      <clipPath id="c">
        <path
          d="M195.398 307.086c.403.523.907.976 1.5 1.316l36.14 20.875 6.02 3.46c.9.52 1.926.74 2.934.665.336-.027.672-.09 1-.183l44.434-81.36c-.34-.37-.738-.68-1.184-.94l-27.586-15.93-14.582-8.39c-.414-.24-.863-.41-1.32-.53zm0 0"
          class="svg-elem-2"
        ></path>
      </clipPath>
      <linearGradient
        id="d"
        x1="-.456"
        x2=".582"
        gradientTransform="rotate(-36.46 550.846 -214.337) scale(132.798)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".57" stop-color="#3E863D"></stop>
        <stop offset=".72" stop-color="#619857"></stop>
        <stop offset="1" stop-color="#76AC64"></stop>
      </linearGradient>
      <clipPath id="e">
        <path
          d="M241.066 225.953c-.707.07-1.398.29-2.035.652l-42.01 24.247 45.3 82.51c.63-.09 1.25-.3 1.81-.624l42.13-24.336c1.3-.754 2.19-2.03 2.46-3.476l-46.18-78.89c-.34-.067-.68-.102-1.03-.102-.14 0-.28.007-.42.02"
          class="svg-elem-3"
        ></path>
      </clipPath>
      <linearGradient
        id="f"
        x1=".043"
        x2=".984"
        gradientTransform="translate(192.862 279.652) scale(97.417)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".16" stop-color="#6BBF47"></stop>
        <stop offset=".38" stop-color="#79B461"></stop>
        <stop offset=".47" stop-color="#75AC64"></stop>
        <stop offset=".7" stop-color="#659E5A"></stop>
        <stop offset=".9" stop-color="#3E863D"></stop>
      </linearGradient>
    </defs>
    <path
      fill="#4DBA87"
      d="M218.647 270.93c-1.46 0-2.91-.383-4.19-1.12l-13.337-7.896c-1.992-1.114-1.02-1.508-.363-1.735 2.656-.93 3.195-1.14 6.03-2.75.298-.17.688-.11.993.07l10.246 6.08c.37.2.895.2 1.238 0l39.95-23.06c.37-.21.61-.64.61-1.08v-46.1c0-.46-.24-.87-.618-1.1l-39.934-23.04c-.37-.22-.86-.22-1.23 0l-39.926 23.04c-.387.22-.633.65-.633 1.09v46.1c0 .44.24.86.62 1.07l10.94 6.32c5.94 2.97 9.57-.53 9.57-4.05v-45.5c0-.65.51-1.15 1.16-1.15h5.06c.63 0 1.15.5 1.15 1.15v45.52c0 7.92-4.32 12.47-11.83 12.47-2.31 0-4.13 0-9.21-2.5l-10.48-6.04c-2.59-1.5-4.19-4.3-4.19-7.29v-46.1c0-3 1.6-5.8 4.19-7.28l39.99-23.07c2.53-1.43 5.89-1.43 8.4 0l39.94 23.08c2.58 1.49 4.19 4.28 4.19 7.28v46.1c0 2.99-1.61 5.78-4.19 7.28l-39.94 23.07c-1.28.74-2.73 1.12-4.21 1.12"
      class="svg-elem-4"
    ></path>
    <path
      fill="#4DBA87"
      d="M230.987 239.164c-17.48 0-21.145-8.024-21.145-14.754 0-.64.516-1.15 1.157-1.15h5.16c.57 0 1.05.415 1.14.978.78 5.258 3.1 7.91 13.67 7.91 8.42 0 12-1.902 12-6.367 0-2.57-1.02-4.48-14.1-5.76-10.94-1.08-17.7-3.49-17.7-12.24 0-8.06 6.8-12.86 18.19-12.86 12.79 0 19.13 4.44 19.93 13.98.03.33-.09.65-.31.89-.22.23-.53.37-.85.37h-5.19c-.54 0-1.01-.38-1.12-.9-1.25-5.53-4.27-7.3-12.48-7.3-9.19 0-10.26 3.2-10.26 5.6 0 2.91 1.26 3.76 13.66 5.4 12.28 1.63 18.11 3.93 18.11 12.56 0 8.7-7.26 13.69-19.92 13.69m48.66-48.89h1.34c1.1 0 1.31-.77 1.31-1.22 0-1.18-.81-1.18-1.26-1.18h-1.38zm-1.63-3.78h2.97c1.02 0 3.02 0 3.02 2.28 0 1.59-1.02 1.92-1.63 2.12 1.19.08 1.27.86 1.43 1.96.08.69.21 1.88.45 2.28h-1.83c-.05-.4-.33-2.6-.33-2.72-.12-.49-.29-.73-.9-.73h-1.51v3.46h-1.67zm-3.57 4.3c0 3.58 2.89 6.48 6.44 6.48 3.58 0 6.47-2.96 6.47-6.48 0-3.59-2.93-6.44-6.48-6.44-3.5 0-6.44 2.81-6.44 6.43m14.16.03c0 4.24-3.47 7.7-7.7 7.7-4.2 0-7.7-3.42-7.7-7.7 0-4.36 3.58-7.7 7.7-7.7 4.15 0 7.69 3.35 7.69 7.7"
      class="svg-elem-5"
    ></path>
    <path
      fill="#4DBA87"
      fill-rule="evenodd"
      d="M94.936 90.55c0-1.84-.97-3.53-2.558-4.445l-42.356-24.37c-.715-.42-1.516-.64-2.328-.67h-.438c-.812.03-1.613.25-2.34.67L2.562 86.105C.984 87.025 0 88.715 0 90.555l.093 65.64c0 .91.47 1.76 1.27 2.21.78.48 1.76.48 2.54 0l25.18-14.42c1.59-.946 2.56-2.618 2.56-4.44V108.88c0-1.83.97-3.52 2.555-4.43l10.72-6.174c.796-.46 1.67-.688 2.56-.688.876 0 1.77.226 2.544.687l10.715 6.172c1.586.91 2.56 2.6 2.56 4.43v30.663c0 1.82.983 3.5 2.565 4.44l25.164 14.41c.79.47 1.773.47 2.56 0 .776-.45 1.268-1.3 1.268-2.21zm199.868 34.176c0 .457-.243.88-.64 1.106l-14.548 8.386c-.395.227-.883.227-1.277 0l-14.55-8.386c-.4-.227-.64-.65-.64-1.106V107.93c0-.458.24-.88.63-1.11l14.54-8.4c.4-.23.89-.23 1.29 0l14.55 8.4c.4.23.64.652.64 1.11zM298.734.324c-.794-.442-1.76-.43-2.544.027-.78.46-1.262 1.3-1.262 2.21v65c0 .64-.34 1.23-.894 1.55-.55.32-1.235.32-1.79 0L281.634 63c-1.58-.914-3.526-.914-5.112 0l-42.37 24.453c-1.583.91-2.56 2.6-2.56 4.42v48.92c0 1.83.977 3.51 2.56 4.43l42.37 24.47c1.582.91 3.53.91 5.117 0l42.37-24.48c1.58-.92 2.56-2.6 2.56-4.43V18.863c0-1.856-1.01-3.563-2.63-4.47zm141.093 107.164c1.574-.914 2.543-2.602 2.543-4.422V91.21c0-1.824-.97-3.507-2.547-4.425l-42.1-24.44c-1.59-.92-3.54-.92-5.13 0l-42.36 24.45c-1.59.92-2.56 2.6-2.56 4.43v48.9c0 1.84.99 3.54 2.58 4.45l42.09 23.99c1.55.89 3.45.9 5.02.03l25.46-14.15c.8-.45 1.31-1.3 1.31-2.22 0-.92-.49-1.78-1.29-2.23l-42.62-24.46c-.8-.45-1.29-1.3-1.29-2.21v-15.34c0-.916.48-1.76 1.28-2.216l13.26-7.65c.79-.46 1.76-.46 2.55 0l13.27 7.65c.79.45 1.28 1.3 1.28 2.21v12.06c0 .91.49 1.76 1.28 2.22.79.45 1.77.45 2.56-.01zm0 0"
      class="svg-elem-6"
    ></path>
    <path
      fill="#4DBA87"
      fill-rule="evenodd"
      d="M394.538 105.2c.3-.177.676-.177.98 0l8.13 4.69c.304.176.49.5.49.85v9.39c0 .35-.186.674-.49.85l-8.13 4.69c-.304.177-.68.177-.98 0l-8.125-4.69c-.31-.176-.5-.5-.5-.85v-9.39c0-.35.18-.674.49-.85zm0 0"
      class="svg-elem-7"
    ></path>
    <g clip-path="url(#a)" transform="translate(-78.306 -164.016)">
      <path
        fill="#4DBA87"
        d="M331.363 246.793l-118.715-58.19-60.87 124.174L270.49 370.97zm0 0"
        class="svg-elem-8"
      ></path>
    </g>
    <g clip-path="url(#c)" transform="translate(-78.306 -164.016)">
      <path
        fill="#4DBA87"
        d="M144.07 264.004l83.825 113.453 110.86-81.906-83.83-113.45zm0 0"
        class="svg-elem-9"
      ></path>
    </g>
    <g clip-path="url(#e)" transform="translate(-78.306 -164.016)">
      <path
        fill="#4DBA87"
        d="M197.02 225.934v107.43h91.683v-107.43zm0 0"
        class="svg-elem-10"
      ></path>
    </g>
  </svg>
);
